import React from "react";
import { Helmet } from "react-helmet";
import { getPageTitle } from "../../helpers/envTitle";
import "./style.css";

export const LearnMore = () => {
  return (
    <div className="learn-more__wrapper">
      <Helmet>
        <title>{getPageTitle()}</title>
      </Helmet>
      <div className="learn-more__content">
        <h1>Coming Soon</h1>
        <p>We're working on something amazing. Check back soon!</p>
      </div>
    </div>
  );
};




